<template>
  <div class="academic">
    <h1 class="title">·信息公告</h1>

    <div class="academic-list">
      <ul>
        <li class="active-item">
          <a target="view_window"
             href="https://mp.weixin.qq.com/s/ztw1p6CcZZz7esxBodxRUA">
            <p class="left">JOIN US丨管乐教师看这里，这是你梦寐以求的平台！</p>
            <p class="right">2019-08-09</p>
          </a>
        </li>
      </ul>
    </div>
  </div>
</template>

<style lang="less" scoped>
.academic {
  padding: 0 32px;
  min-height: 500px;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.11);
  .title {
    position: relative;
    padding: 20px 0;
    color: #08433f;
    font-size: 25px;
    line-height: 55px;
    font-weight: bold;
    &:after {
      content: "";
      height: 5px;
      width: 100%;
      background: rgba(20, 146, 138, 1);
      z-index: 10;
      position: absolute;
      left: 0;
      bottom: 0;
    }
    // padding: 25px 0 20px;
    color: #08433f;
    font-size: 25px;
    line-height: 55px;
  }

  .academic-list {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    flex-wrap: wrap;
    -webkit-flex-wrap: wrap;
    padding-bottom: 149px;
    ul {
      display: block;
      width: 100%;
      .active-item {
        display: block;
        height: 70px;
        line-height: 70px;
        border-bottom: 1px solid #cecece;
        a {
          text-decoration: none;
          color: #4a4a4a;
          cursor: pointer;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          flex-wrap: nowrap;
          .right {
            width: 100px;
            text-align: right;
            font-size: 14px;
            font-family: PingFangSC;
            font-weight: 400;
            color: rgba(74, 74, 74, 1);
          }
              &:hover{ color: #14928a;}
        }
      }
    }

    .acadmic-item {
      margin: 0 24px 20px;
      flex: 0 0 250px;
      box-shadow: 6px 2px 20px 0px rgba(0, 0, 0, 0.06);
      border-radius: 6px;
      img {
        width: 250px;
        height: 354px;
      }
      p {
        width: 250px;
        line-height: 42px;
        padding: 0 8px;
        color: #444;
        font-size: 14px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        box-sizing: border-box;
      }
    }
  }
}
</style>

<script>
export default {
  name: "infoMsg",
  data () {
    return {};
  }
};
</script>
